import React, { useEffect, useState } from "react";
import Moment from "react-moment";
import axios from "axios";
import "./posts.css";
import { NavLink } from "react-router-dom";
import $ from "jquery";
import { LazyLoadImage } from "react-lazy-load-image-component";

const EditPost = (props) => {
  const [params] = useState(props.match.params);
  const [languages, setlanguages] = useState([]);
  const [user] = useState(JSON.parse(localStorage.getItem("user")));
  const [message, setMessage] = useState({
    type: null,
    text: "",
  });
  const [media, setMedia] = useState([]);
  const [post, setPost] = useState({
    id: params.id,
    language: user.language,
    title: "",
    description: "",
    medias: [],
    featured: "",
  });

  const handleChnage = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setPost((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
  };

  const attachedMedia = (e) => {
    let name = e.target.name;
    let value = parseInt(e.target.value);
    let medias = post.medias;
    if (e.target.checked) {
      if (!medias.includes(value)) medias.push(value);
    } else {
      medias.pop(value);
    }

    setPost((prevState) => {
      return {
        ...prevState,
        [name]: medias,
      };
    });
  };

  const attachedFeature = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if (e.target.checked) {
      setPost((prevState) => {
        return {
          ...prevState,
          [name]: value,
        };
      });
    }
  };

  const resetMessage = (e) => {
    setMessage(() => {
      return {
        type: null,
        message: "",
      };
    });
  };

  const sevePost = async (e) => {
    e.preventDefault();
    let error = false;
    if (post.title === "") {
      error = true;
      setMessage(() => {
        return {
          type: "danger",
          message: "Please enter post title.",
        };
      });
      return;
    }
    if (post.description === "") {
      error = true;
      setMessage(() => {
        return {
          type: "danger",
          message: "Please enter post description.",
        };
      });
      return;
    }

    if (post.medias.length > 0 && post.featured === "") {
      error = true;
      setMessage(() => {
        return {
          type: "danger",
          message: "Please choose feature media.",
        };
      });
      return;
    }
    if (!error) {
      await axios
        .put(
          localStorage.getItem("basurl") + "/posts",
          {
            language: post.language,
            id: post.id,
            title: post.title,
            description: post.description,
            medias: post.medias,
            featured: post.featured,
          },
          { headers: { "mojo-access-tokens": user.token } }
        )
        .then((response) => {
          setMessage(() => {
            return {
              type: "success",
              message: response.data.message,
            };
          });
          document.getElementsByName("medias").forEach(function (box) {
            box.checked = false;
          });
          document.getElementsByName("featured").forEach(function (box) {
            box.checked = false;
          });
          setPost({ title: "", description: "", medias: [] });
        })
        .catch((error) => {
          setMessage(() => {
            return {
              type: "danger",
              message: error.response.data.message,
            };
          });
        });
    }
  };

  const getMessage = () => {
    if (message.type) {
      return (
        <div className={`alert alert-${message.type}`} role="alert">
          <button type="button" className="close" onClick={resetMessage}>
            <span aria-hidden="true">&times;</span>
          </button>
          <strong className="d-block d-sm-inline-block-force">
            {message.type === "success" ? "Well done!" : "Oops!"}
          </strong>{" "}
          {message.message}
        </div>
      );
    }
  };

  const mediaobject = (item) => {
    switch (item.file_type) {
      case "video/mp4":
        return (
          <video className="thumbnail" controls alt={item.link}>
            <source
              src={`${localStorage.getItem("baseimageurl")}/media/${item.link}`}
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        );
      case "image/jpeg":
        return (
          <LazyLoadImage
            className="thumbnail"
            src={`${localStorage.getItem("baseimageurl")}/media/${item.link}`}
            alt={item.link}
          />
        );
      case "image/png":
        return (
          <LazyLoadImage
            className="thumbnail"
            src={`${localStorage.getItem("baseimageurl")}/media/${item.link}`}
            alt={item.link}
          />
        );
      case "audio/mpeg":
        return (
          <audio className="thumbnail" controls alt={item.link}>
            <source
              src={`${localStorage.getItem("baseimageurl")}/media/${item.link}`}
              type="audio/mpeg"
            />
            Your browser does not support the audio tag.
          </audio>
        );
      default:
        return <span>---</span>;
    }
  };

  const loadMedia = async () => {
    try {
      await axios
        .get(localStorage.getItem("basurl") + "/media-list", {
          headers: {
            "mojo-access-tokens": user.token,
          },
        })
        .then((response) => {
          setMedia(() => {
            return response.data;
          });
        })
        .catch((error) => {
          if (
            typeof error.response.data !== undefined &&
            error.response.data.loginRequired
          ) {
            //localStorage.removeItem('user');
            //window.location.href = '/login';
          }
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const getPost = async () => {
    try {
      await axios
        .get(localStorage.getItem("basurl") + "/posts/" + params.id, {
          headers: {
            "mojo-access-tokens": user.token,
          },
        })
        .then((response) => {
          response.data.forEach((value) => {
            let val = value;
            let media = [];
            for (let x in value.medias) {
              media.push(value.medias[x].media_id);
              if (value.medias[x].featured) {
                val.featured = value.medias[x].media_id;
              }
            }
            val["medias"] = media;
            setPost((prevState) => {
              return {
                ...prevState,
                ...val,
              };
            });
          });
        })
        .catch((error) => {
          if (
            typeof error.response.data !== undefined &&
            error.response.data.loginRequired
          ) {
            localStorage.removeItem("user");
            window.location.href = "/login";
          }
          console.log(error);
        });
    } catch (err) {
      console.log(err);
    }
  };

  const getLanguage = async () => {
    try {
      await axios
        .get(localStorage.getItem("basurl") + "/languages")
        .then((response) => {
          setlanguages(response.data);
        })
        .catch((err) => {
          setMessage(() => {
            return {
              type: "danger",
              message: err.response.data.message,
            };
          });
        });
    } catch (err) {
      setMessage(() => {
        return {
          type: "danger",
          message: err.message,
        };
      });
    }
  };

  const wordCount = (e) => {
    let maxwords = 400;
    let desc = e.target.value.trim();
    var words = 0;

    if (desc !== "") {
      words = desc.split(" ").length;
    }
    let wordsLeft = maxwords - words;
    if (words > maxwords) {
      //var trimmed = desc.split(" ", maxwords).join(" ");
      //$('#description').val(trimmed + " ");
    } else {
      $("#word_left").removeClass("alert-danger");
      if (wordsLeft <= maxwords / 10) {
        $("#word_left").addClass("alert-danger");
      }
    }
    $("#word_left").html("Words left: <b>" + wordsLeft + "</b>");
  };

  useEffect(() => {
    getLanguage();
    getPost();
    loadMedia();
  }, []);

  return (
    <>
      <div className="card shadow-base form-layout form-layout-4">
        <h6 className="tx-gray-800 tx-uppercase tx-bold tx-14 mg-b-10">
          Update a Post
        </h6>
        <p className="mg-b-30 tx-gray-600">
          Fields masked with <span className="tx-danger">*</span> are required.
        </p>
        {getMessage()}
        <div className="row">
          <label className="col-sm-4 form-control-label">
            Language: <span className="tx-danger">*</span>
          </label>
          <div className="col-sm-8 mg-t-5 mg-sm-t-0">
            <select
              id="signup-language"
              name="language"
              onFocus={resetMessage}
              onChange={handleChnage}
              placeholder="Please choose your language"
              className="form-control"
              value={post.language}
            >
              {languages.map((lang) => (
                <option
                  key={`lang` + lang.id}
                  value={lang.id}
                  selected={lang.id === post.language ? true : false}
                >
                  {lang.name}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="row mg-t-20">
          <label className="col-sm-4 form-control-label">
            Title: <span className="tx-danger">*</span>
          </label>
          <div className="col-sm-8 mg-t-10 mg-sm-t-0">
            <input
              name="title"
              type="text"
              className="form-control"
              placeholder="Enter post title"
              autoComplete="off"
              onFocus={resetMessage}
              onChange={handleChnage}
              value={post.title}
            />
          </div>
        </div>
        <div className="row mg-t-20">
          <label className="col-sm-4 form-control-label">
            Description: <span className="tx-danger">*</span>
          </label>
          <div className="col-sm-8 mg-t-10 mg-sm-t-0">
            <textarea
              name="description"
              rows={6}
              className="form-control"
              placeholder="Enter post description"
              autoComplete="off"
              onFocus={resetMessage}
              onKeyUp={wordCount}
              onChange={handleChnage}
              value={post.description}
            />
            <div id="word_left"></div>
          </div>
        </div>
        <div className="row mg-t-20">
          <label className="col-sm-4 form-control-label">Attach Media:</label>
          <div className="col-sm-8 mg-t-10 mg-sm-t-0">
            <div className="bd rounded table-responsive">
              <table className="table table-responsive table-bordered">
                <thead>
                  <tr>
                    <th></th>
                    <th>Media</th>
                    <th>Media Name</th>
                    <th>Featured Media</th>
                  </tr>
                </thead>
                <tbody>
                  {media.length ? (
                    media.map((item) => (
                      <tr key={item.id}>
                        <td
                          className="valign-middle"
                          onClick={attachedMedia}
                          name="medias"
                          value={item.id}
                          style={{ padding: "0.30rem" }}
                        >
                          <input
                            className="pointer"
                            name="medias"
                            type="checkbox"
                            value={item.id}
                          />
                        </td>
                        <td
                          className="valign-middle"
                          style={{ padding: "0.30rem" }}
                        >
                          {mediaobject(item)}
                        </td>
                        <td
                          className="valign-middle tx-center"
                          style={{ padding: "0.30rem" }}
                        >
                          <span className="d-block">{item.media_title}</span>
                          <span className="tx-success d-block">
                            <Moment date={item.created_at1} local fromNow />
                          </span>
                        </td>
                        <td className="tx-center valign-middle">
                          <span>
                            {item.file_type === "image/png" ||
                            item.file_type === "image/jpeg" ? (
                              <input
                                className="pointer"
                                type="radio"
                                name="featured"
                                value={item.id}
                                onClick={attachedFeature}
                              />
                            ) : (
                              <> - </>
                            )}
                          </span>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="tx-center">
                        You have not uploaded any file yet.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="form-layout-footer mg-t-30 tx-right">
          <NavLink to="/posts"> My Posts </NavLink> &nbsp; &nbsp; &nbsp;
          <button
            onClick={sevePost}
            className="btn btn-info"
            style={{ cursor: "pointer" }}
          >
            Save
          </button>
          &nbsp;&nbsp;
        </div>
      </div>
    </>
  );
};

export default EditPost;
